// import { FakeMasonry } from '@components/FakeMasonry/FakeMasonry';

import plant_boat_1080p_av1 from '@assets/login/optimized/plant-boat/plant-boat_1080p_av1.mp4';
import plant_boat_1080p_h264 from '@assets/login/optimized/plant-boat/plant-boat_1080p_h264.mp4';
import plant_boat_720p_av1 from '@assets/login/optimized/plant-boat/plant-boat_720p_av1.mp4';
import plant_boat_720p_h264 from '@assets/login/optimized/plant-boat/plant-boat_720p_h264.mp4';
import plant_boat_poster from '@assets/login/optimized/plant-boat/plant-boat_poster.jpg';

import earth_1080p_av1 from '@assets/login/optimized/earth/earth_1080p_av1.mp4';
import earth_1080p_h264 from '@assets/login/optimized/earth/earth_1080p_h264.mp4';
import earth_720p_av1 from '@assets/login/optimized/earth/earth_720p_av1.mp4';
import earth_720p_h264 from '@assets/login/optimized/earth/earth_720p_h264.mp4';
import earth_poster from '@assets/login/optimized/earth/earth_poster.jpg';

import fireman_1080p_av1 from '@assets/login/optimized/fire-man/fire-man_1080p_av1.mp4';
import fireman_1080p_h264 from '@assets/login/optimized/fire-man/fire-man_1080p_h264.mp4';
import fireman_720p_av1 from '@assets/login/optimized/fire-man/fire-man_720p_av1.mp4';
import fireman_720p_h264 from '@assets/login/optimized/fire-man/fire-man_720p_h264.mp4';
import fireman_poster from '@assets/login/optimized/fire-man/fire-man_poster.jpg';

import mountain_1080p_av1 from '@assets/login/optimized/mountain/mountain_1080p_av1.mp4';
import mountain_1080p_h264 from '@assets/login/optimized/mountain/mountain_1080p_h264.mp4';
import mountain_720p_av1 from '@assets/login/optimized/mountain/mountain_720p_av1.mp4';
import mountain_720p_h264 from '@assets/login/optimized/mountain/mountain_720p_h264.mp4';
import mountain_poster from '@assets/login/optimized/mountain/mountain_poster.jpg';

import singer_1080p_av1 from '@assets/login/optimized/singer/singer_1080p_av1.mp4';
import singer_1080p_h264 from '@assets/login/optimized/singer/singer_1080p_h264.mp4';
import singer_720p_av1 from '@assets/login/optimized/singer/singer_720p_av1.mp4';
import singer_720p_h264 from '@assets/login/optimized/singer/singer_720p_h264.mp4';
import singer_poster from '@assets/login/optimized/singer/singer_poster.jpg';

import space_1080p_av1 from '@assets/login/optimized/space/space_1080p_av1.mp4';
import space_1080p_h264 from '@assets/login/optimized/space/space_1080p_h264.mp4';
import space_720p_av1 from '@assets/login/optimized/space/space_720p_av1.mp4';
import space_720p_h264 from '@assets/login/optimized/space/space_720p_h264.mp4';
import space_poster from '@assets/login/optimized/space/space_poster.jpg';

import tea_1080p_av1 from '@assets/login/optimized/tea/tea_1080p_av1.mp4';
import tea_1080p_h264 from '@assets/login/optimized/tea/tea_1080p_h264.mp4';
import tea_720p_av1 from '@assets/login/optimized/tea/tea_720p_av1.mp4';
import tea_720p_h264 from '@assets/login/optimized/tea/tea_720p_h264.mp4';
import tea_poster from '@assets/login/optimized/tea/tea_poster.jpg';

import swan_1080p_av1 from '@assets/login/optimized/swan-taking-off/swan-taking-off_1080p_av1.mp4';
import swan_1080p_h264 from '@assets/login/optimized/swan-taking-off/swan-taking-off_1080p_h264.mp4';
import swan_720p_av1 from '@assets/login/optimized/swan-taking-off/swan-taking-off_720p_av1.mp4';
import swan_720p_h264 from '@assets/login/optimized/swan-taking-off/swan-taking-off_720p_h264.mp4';
import swan_poster from '@assets/login/optimized/swan-taking-off/swan-taking-off_poster.jpg';

import flamingos_1080p_av1 from '@assets/login/optimized/slow-motion-flamingos/slow-motion-flamingos_1080p_av1.mp4';
import flamingos_1080p_h264 from '@assets/login/optimized/slow-motion-flamingos/slow-motion-flamingos_1080p_h264.mp4';
import flamingos_720p_av1 from '@assets/login/optimized/slow-motion-flamingos/slow-motion-flamingos_720p_av1.mp4';
import flamingos_720p_h264 from '@assets/login/optimized/slow-motion-flamingos/slow-motion-flamingos_720p_h264.mp4';
import flamingos_poster from '@assets/login/optimized/slow-motion-flamingos/slow-motion-flamingos_poster.jpg';

import aircraft_1080p_av1 from '@assets/login/optimized/light-aircrafts/light-aircrafts_1080p_av1.mp4';
import aircraft_1080p_h264 from '@assets/login/optimized/light-aircrafts/light-aircrafts_1080p_h264.mp4';
import aircraft_720p_av1 from '@assets/login/optimized/light-aircrafts/light-aircrafts_720p_av1.mp4';
import aircraft_720p_h264 from '@assets/login/optimized/light-aircrafts/light-aircrafts_720p_h264.mp4';
import aircraft_poster from '@assets/login/optimized/light-aircrafts/light-aircrafts_poster.jpg';

import couple_1080p_av1 from '@assets/login/optimized/couple-posing/couple-posing_1080p_av1.mp4';
import couple_1080p_h264 from '@assets/login/optimized/couple-posing/couple-posing_1080p_h264.mp4';
import couple_720p_av1 from '@assets/login/optimized/couple-posing/couple-posing_720p_av1.mp4';
import couple_720p_h264 from '@assets/login/optimized/couple-posing/couple-posing_720p_h264.mp4';
import couple_poster from '@assets/login/optimized/couple-posing/couple-posing_poster.jpg';

import aerial_1080p_av1 from '@assets/login/optimized/aerial-view/aerial-view_1080p_av1.mp4';
import aerial_1080p_h264 from '@assets/login/optimized/aerial-view/aerial-view_1080p_h264.mp4';
import aerial_720p_av1 from '@assets/login/optimized/aerial-view/aerial-view_720p_av1.mp4';
import aerial_720p_h264 from '@assets/login/optimized/aerial-view/aerial-view_720p_h264.mp4';
import aerial_poster from '@assets/login/optimized/aerial-view/aerial-view_poster.jpg';

import { FakeMasonry } from '@components/FakeMasonry/FakeMasonry';
import { useMemo } from 'react';
import css from './AuthHero.module.scss';

const orientations: Array<'horizontal' | 'vertical'> = [
  'horizontal',
  'vertical',
  'horizontal',
  'vertical',
  'horizontal',
  'horizontal',
  'horizontal',
  'horizontal',
  'horizontal',
  'horizontal',
  'horizontal',
  'horizontal',
];

const horizontalVideos = [
  {
    poster: space_poster,
    sources: [
      {
        '720p': space_720p_av1,
        '1080p': space_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': space_720p_h264,
        '1080p': space_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: plant_boat_poster,
    sources: [
      {
        '720p': plant_boat_720p_av1,
        '1080p': plant_boat_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': plant_boat_720p_h264,
        '1080p': plant_boat_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: mountain_poster,
    sources: [
      {
        '720p': mountain_720p_av1,
        '1080p': mountain_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': mountain_720p_h264,
        '1080p': mountain_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: tea_poster,
    sources: [
      {
        '720p': tea_720p_av1,
        '1080p': tea_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': tea_720p_h264,
        '1080p': tea_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: fireman_poster,
    sources: [
      {
        '720p': fireman_720p_av1,
        '1080p': fireman_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': fireman_720p_h264,
        '1080p': fireman_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: swan_poster,
    sources: [
      {
        '720p': swan_720p_av1,
        '1080p': swan_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': swan_720p_h264,
        '1080p': swan_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: flamingos_poster,
    sources: [
      {
        '720p': flamingos_720p_av1,
        '1080p': flamingos_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': flamingos_720p_h264,
        '1080p': flamingos_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: aircraft_poster,
    sources: [
      {
        '720p': aircraft_720p_av1,
        '1080p': aircraft_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': aircraft_720p_h264,
        '1080p': aircraft_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: couple_poster,
    sources: [
      {
        '720p': couple_720p_av1,
        '1080p': couple_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': couple_720p_h264,
        '1080p': couple_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    poster: aerial_poster,
    sources: [
      {
        '720p': aerial_720p_av1,
        '1080p': aerial_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': aerial_720p_h264,
        '1080p': aerial_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
];

const verticalVideos = [
  {
    poster: earth_poster,
    sources: [
      {
        '720p': earth_720p_av1,
        '1080p': earth_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': earth_720p_h264,
        '1080p': earth_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
  {
    /*
      This element must be the last one (i.e. the first one in reverse order),
      otherwise the guy will not look like a musician.
    */
    poster: singer_poster,
    sources: [
      {
        '720p': singer_720p_av1,
        '1080p': singer_1080p_av1,
        type: 'video/mp4; codecs=av01.0.04M.08',
      },
      {
        '720p': singer_720p_h264,
        '1080p': singer_1080p_h264,
        type: 'video/mp4; codecs=avc1.4D401E',
      },
    ],
  },
];
export const AuthHero = ({ width }: { width: number }) => {
  const cells = useMemo(() => {
    const horizontalVideoIndices = horizontalVideos
      .map((_, i) => i)
      .sort(() => Math.random() - 0.5);
    const verticalVideoIndices = verticalVideos.map((_, i) => i);

    return orientations.map((orientation, index) => {
      const videoArray = orientation === 'horizontal' ? horizontalVideos : verticalVideos;
      let currentIndex =
        orientation === 'horizontal' ? horizontalVideoIndices.pop() : verticalVideoIndices.pop();
      if (currentIndex === undefined) currentIndex = 0;
      const video = videoArray[currentIndex];

      return {
        orientation,
        children: (
          <video poster={video.poster} autoPlay muted loop playsInline className={css.video}>
            {video.sources.map((source, i) => (
              <source
                key={i}
                src={width > 3800 ? source['1080p'] : source['720p']}
                type={source.type}
              />
            ))}
          </video>
        ),
      };
    });
  }, []);

  return <FakeMasonry maxColumnCount={2} width={width} minCellWidth={300} cells={cells} />;
};
